import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'freetrialPlans.whatYouGet.title',
		defaultMessage: 'What you get with Calm Premium',
		description: 'Heading for features section',
	},
	dailyCalmCopy: {
		id: 'freeTrialPlans.whatYouGet.dailyCalm',
		defaultMessage: 'An original Daily Calm every day.',
		description: 'Daily Calm tile copy',
	},
	meditationsCopy: {
		id: 'freeTrialPlans.whatYouGet.meditations',
		defaultMessage: 'Hundreds of hours of guided meditation covering anxiety, stress, sleep, and more.',
		description: 'Meditations tile copy',
	},
	musicCopy: {
		id: 'freeTrialPlans.whatYouGet.music',
		defaultMessage: 'Exclusive music tracks for focus, relaxation, and sleep, with new music added weekly.',
		description: 'Music tile copy',
	},
	sleepStoriesCopy: {
		id: 'freeTrialPlans.whatYouGet.sleepStories',
		defaultMessage: 'Entire library of over 100 Sleep Stories, with new stories added every week.',
		description: 'Sleep stories tile copy',
	},
	matserclassCopy: {
		id: 'freeTrialPlans.whatYouGet.masterclass2',
		defaultMessage: 'Life-changing Calm Masterclasses taught by world-renowned experts.',
		description: 'Masterclass tile copy',
	},
	bodyCopy: {
		id: 'freeTrialPlans.whatYouGet.body',
		defaultMessage:
			'Access to all Calm Body programs. A series of videos lessons on gentle stretching and movement.',
		description: 'Body tile copy',
	},
	cta: {
		id: 'freeTrialPlans.button.cta',
		defaultMessage: 'Start free trial',
		description: 'Button cta for what you get section',
	},
});
